/**
 * This hook is for the market state.
 * In the hook, we check the status of the market and we return human-readable data together with enums
 */
import lang from '../../../language';
import { InfoStatusType, MarketState, MarketStateAndStatus } from '../../../models/market-data/types';
import MarketStateCache from '../../../store-util/MarketStateCache';

const {
  PreMarket,
  RegularHours,
  AfterMarket,
  MarketClosed,
} = MarketState;

export const useMarketStateInfo = (hasAfterMarketData = false): MarketStateAndStatus => {
  const { marketState } = MarketStateCache.use();
  let status: InfoStatusType;
  let statusLabel: string;
  switch (marketState) {
    case PreMarket:
      status = 'pre';
      statusLabel = lang.commonMarketHoursPre();
      break;
    case AfterMarket:
      status = 'after';
      statusLabel = lang.commonMarketHoursAfter();
      break;
    case MarketClosed:
      status = hasAfterMarketData ? 'after' : 'close';
      statusLabel = hasAfterMarketData ? lang.commonMarketHoursAfter() : lang.commonMarketHoursAtClose();
      break;
    case RegularHours:
    default:
      status = 'none';
      statusLabel = '';
      break;
  }

  return {
    marketState,
    status,
    statusLabel,
  };
};
